import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import i18n from '@/plugin/i18n';

Vue.use(VueSweetalert2);

// Add a confirm method to Vue's prototype
Vue.prototype.$confirm = function(message, options = {}) {
  const defaultOptions = {
    title: i18n.t('Warning') || 'Warning',
    color: 'primary',
    width: 400,
    html: false // Default to text mode
  };
  
  // Merge default options with user options
  const finalOptions = { ...defaultOptions, ...options };
  
  return new Promise((resolve, reject) => {
    // Use Vue's swal instance
    const swalOptions = {
      title: finalOptions.title,
      icon: finalOptions.color === 'warning' ? 'warning' : 'question',
      showCancelButton: true,
      confirmButtonColor: '#1E88E5',
      confirmButtonText: i18n.t('Yes'),
      cancelButtonColor: '#fff',
      cancelButtonText: `<div style='color: #1E88E5'>${i18n.t('Cancel')}</div>`,
      showLoaderOnConfirm: true,
      allowOutsideClick: false
    };
    
    // Set either text or html property based on options
    if (finalOptions.html) {
      swalOptions.html = message;
    } else {
      swalOptions.text = message;
    }
    
    this.$swal(swalOptions).then((result) => {
      if (result.isConfirmed) {
        resolve(true);
      } else {
        reject(false);
      }
    }).catch(reject);
  });
};